import React from 'react';
import DeleteIcon from './Icons/DeleteIcon';

const BulkActionsBar = ({ selectedCount, onDelete, show = false }) => {
  const containerClasses = `
  fixed bottom-[56px] left-1/2 transform -translate-x-1/2 bg-custom-dark-gray 
  rounded-xl text-white flex justify-between items-center pt-[13px] pb-[13px] px-4 
  shadow-lg w-full max-w-[461px] transition-all duration-300 ease-in-out
`;

  const visibilityClasses = show
    ? 'opacity-100 translate-y-0 pointer-events-auto'
    : 'opacity-0 translate-y-4 pointer-events-none';

  return (
    <div className={`${containerClasses} ${visibilityClasses}`}>
      <div className="flex items-center space-x-2">
        <div className="grid text-[18px] place-items-center rounded-[4px] bg-white h-[30px] w-[30px] text-custom-light-blue font-bold">
          {selectedCount}
        </div>
        <span className="text-white font-medium text-[18px]">Selected</span>
      </div>
      <button
        onClick={onDelete}
        className="bg-[#343334] text-white pt-[3.5px] pb-[3.5px] px-4 rounded flex items-center text-[18px] space-x-2 leading-[22px]"
        aria-label={`Delete ${selectedCount} items`}
      >
        <DeleteIcon />
        <span>Delete</span>
      </button>
    </div>
  );
};

export default BulkActionsBar;
